import api from "@/services/axios.js";
import {
  UpdateVerificationStatusRequest,
  UpdateVerificationStatusRequestPayload,
} from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const updateVerificationStageStatus = (
  form: UpdateVerificationStatusRequest,
) => {
  const payload: UpdateVerificationStatusRequestPayload = {
    comment: form.comment,
    isAccepted: form.isAccepted,
  };

  if (form.selectingAll) {
    payload.searchVerificationsRequestViewModel = searchHandler(
      form.searchValues,
    );
  } else {
    payload.verificationStagesIds = form.verificationStagesIds;
  }

  return api.post(
    "/api/AdminVerification/update-verification-stage-status",
    payload,
  );
};
